exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".success{background:#8dc63f}.failure{background:#a94442}", ""]);

// exports
